import gradientColor from "../../utility/gradientColor";
import "./Score.scss"

const isDarkThemeActive = () => {
  if (typeof document === "undefined") return false;

  const themeAttribute = document.documentElement?.getAttribute("data-theme");
  if (themeAttribute === "dark") return true;
  if (themeAttribute === "light") return false;

  if (typeof window !== "undefined" && typeof window.matchMedia === "function") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  }

  return false;
};

const Score = ({ score, emptyLabel = "—" }) => {
  const darkModeActive = isDarkThemeActive();
  const numericScore = Number(score);
  const hasScore = score != null && Number.isFinite(numericScore);

  return (
    <div
      className={`score ${hasScore ? "" : "score--empty"}`.trim()}
      style={
        hasScore
          ? { background: gradientColor(numericScore, { darkMode: darkModeActive }) }
          : undefined
      }
    >
      {hasScore ? `${score}%` : emptyLabel}
    </div>
  );
}



export default Score;
